<template>
  <v-menu
    v-model="isMenuOpened"
    offset-y
    content-class="mt-2"
    :nudge-left="menuOffset"
    :close-on-content-click="false"
  >
    <template #activator="{on, attrs, value}">
      <div style="position: relative">
        <div
          class="icon-container"
          v-bind="attrs"
          :style="{
            width: small ? '16px' : '21px',
            height: small ? '16px' : '21px',
          }"
          v-on="on"
        >
          <z-icon color="black" :size="small ? 12 : 15">
            $more_vert_rounded
          </z-icon>
        </div>

        <div v-if="value" class="arrow-menu"></div>
      </div>
    </template>

    <z-card ref="card" width="auto">
      <template #content>
        <v-list dense nav class="pa-0">
          <v-list-item
            v-for="(option, index) in options"
            :key="index"
            class="pa-0 mb-0"
            @click="onClickOption(option.value)"
          >
            <v-list-item-icon class="my-0 mr-2 pt-1">
              <z-icon size="20" color="black">{{ option.icon }}</z-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ option.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <save-group-modal
          v-model="saveGroupModal"
          @save-group="$emit('save-group', $event)"
        >
        </save-group-modal>

        <save-group-modal
          v-model="saveNewGroupModal"
          @save-group="$emit('save-new-group', $event)"
        >
        </save-group-modal>

        <manage-filter-groups-modal
          v-model="manageFilterGroupsModal"
          :filter-groups="filterGroups"
          @delete-group="$emit('delete-group', $event)"
          @include-filters="onIncludeFilters"
        >
        </manage-filter-groups-modal>
      </template>
    </z-card>
  </v-menu>
</template>

<script>
import SaveGroupModal from './modals/SaveGroupModal.vue'
import ManageFilterGroupsModal from './modals/ManageFilterGroupsModal.vue'

export default {
  name: 'ZFilterManagement',
  components: {SaveGroupModal, ManageFilterGroupsModal},
  props: {
    /**
     * @type {Array<{name: string, filters: Array<{id: any, text: string, value: string}>}>}
     */
    filterGroups: {
      type: Array,
      default: () => [],
    },

    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMenuOpened: false,
      cardWidth: 0,

      saveGroupModal: false,
      saveNewGroupModal: false,
      manageFilterGroupsModal: false,
    }
  },

  computed: {
    options() {
      return [
        {
          text: this.$t('save_filter_selection'),
          value: 'save',
          icon: '$library_add_rounded',
        },
        {
          text: this.$t('save_as_new_filter_selection'),
          value: 'save-new',
          icon: '$dynamic_feed',
        },
        {
          text: this.$t('manage_saved_filters'),
          value: 'manage',
          icon: '$open_folder',
        },
      ]
    },

    menuOffset() {
      return this.cardWidth - 30
    },
  },

  watch: {
    isMenuOpened(value) {
      if (value) {
        setTimeout(() => {
          this.cardWidth = this.$refs.card.$el.offsetWidth
        }, 50)
      }
    },
  },

  methods: {
    onClickOption(value) {
      switch (value) {
        case 'save':
          this.saveGroupModal = true
          break
        case 'save-new':
          this.saveNewGroupModal = true
          break
        case 'manage':
          this.manageFilterGroupsModal = true
          break
      }
    },

    onIncludeFilters(evt) {
      this.$emit('include-filters', evt)
      this.isMenuOpened = false
    },
  },

  i18n: {
    messages: {
      pt: {
        save_filter_selection: 'Salvar seleção de filtro',
        save_as_new_filter_selection: 'Salvar como nova seleção de filtro',
        manage_saved_filters: 'Gerenciar filtros salvos',
      },

      en: {
        save_filter_selection: 'Save filter selection',
        save_as_new_filter_selection: 'Save as new filter selection',
        manage_saved_filters: 'Manage saved filters',
      },

      es: {
        save_filter_selection: 'Guardar selección de filtro',
        save_as_new_filter_selection: 'Guardar como nueva selección de filtro',
        manage_saved_filters: 'Administrar filtros guardados',
      },
      fr: {
        save_filter_selection: 'Enregistrer la sélection de filtre',
        save_as_new_filter_selection:
          'Enregistrer en tant que nouvelle sélection de filtre',
        manage_saved_filters: 'Gérer les filtres enregistrés',
      },
      tr: {
        save_filter_selection: 'Filtre seçimini kaydet',
        save_as_new_filter_selection: 'Yeni bir filtre seçimi olarak kaydet',
        manage_saved_filters: 'Kayıtlı filtreleri yönet',
      },
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.v-list-item) {
  height: 30px !important;
  min-height: 30px !important;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--black);
  border-radius: 50%;
}

.custom-title {
  /* Body/Default Title Case */
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 18px */
  text-transform: capitalize;
}
.arrow-menu {
  transform: translateX(-50%);
  position: absolute;
  border-bottom: solid 8px var(--white) !important;
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  top: 22px;
  left: 50%;
  height: 0px;
  width: 0px;
  z-index: 9;
}
</style>
